import { render, staticRenderFns } from "./ThirdAdminComp.vue?vue&type=template&id=c11b184a&scoped=true&"
import script from "./ThirdAdminComp.vue?vue&type=script&lang=js&"
export * from "./ThirdAdminComp.vue?vue&type=script&lang=js&"
import style0 from "./ThirdAdminComp.vue?vue&type=style&index=0&id=c11b184a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c11b184a",
  null
  
)

export default component.exports